import { useState } from "react";
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { MobileNavDrawer } from "./MobileNavDrawer";
import { useIsNavCollapsed } from "../lib/useMediaQuery";

export function AppShell() {
  const navCollapsed = useIsNavCollapsed();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: navCollapsed ? "1fr" : "240px 1fr",
        // dvh keeps the shell off the mobile URL bar; vh-capable browsers
        // that lack dvh fall back via the CSS string itself.
        height: "100dvh",
        minHeight: "100vh",
        background: "var(--bg-primary)",
      }}
    >
      {navCollapsed ? (
        <MobileNavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
          <Sidebar onNavigate={() => setDrawerOpen(false)} />
        </MobileNavDrawer>
      ) : (
        <Sidebar />
      )}

      <div
        style={{
          display: "grid",
          gridTemplateRows: "56px 1fr",
          overflow: "hidden",
        }}
      >
        <Topbar
          navCollapsed={navCollapsed}
          onMenuClick={() => setDrawerOpen(true)}
        />
        <main
          style={{
            overflow: "auto",
            background: "var(--bg-primary)",
          }}
        >
          <div
            style={{
              padding: "var(--canvas-pad) var(--canvas-pad-x)",
              maxWidth: 1320,
              minHeight: "100%",
            }}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
